/*
 * Модуль для отправки данных формы на сервер
 */

import * as Sender from './../sender.js'

var getEndpointUrl = function() {
    return process.env.VUE_APP_API_BASE_URL + '/api/bid/create';
};

var getRequestPayload = function(form) {
    return {
        fio: form.fio,
        phone: form.phone,
        host: window.location.hostname,
        geoByIp: true,
        consent: true,
        bankruptcy: {
            debt: form.debt ?? 1,
            property: form.property ?? false,
        },
        utm: Sender.getUtms(),
    };
};

var send = function(form) {
    return Sender.send(getEndpointUrl(), getRequestPayload(form));
};

export { send }
